export default {
  'ActiveRevenue':{
    img:{
      src: 'active-revenue.png',
    }
  },
  '7Search PPC':{
    img:{
      src: '7searchppc.png',
    }
  },
  'Ad-Maven':{
    img:{
      src: 'ad-maven.png',
    }
  },
  'AdsKeeper':{
    img:{
      src: 'ads-keeper.svg',
    }
  },
  'AdsTerra':{
    img:{
      src: 'adsterra.svg',
    }
  },
  'Clickadu':{
    img:{
      src: 'clickadu.png',
    }
  },
  'ExoClick':{
    img:{
      src: 'ex-oclick.svg',
    },
    style:{
      'max-height':'20px'
    }
  },
  'EZmob':{
    img:{
      src: 'ezmob.png',
    },
    style:{
      'max-height':'30px'
    }
  },
  'Facebook':{
    img:{
      src: 'facebook.svg',
    },
    style:{
      'max-height':'20px'
    }
  },
  'Google Adwords':{
    img:{
      src: 'google-ads.png',
    }
  },
  'HilltopAds':{
    img:{
      src: 'hilltopads.png',
    }
  },
  'BidVertiser':{
    img:{
      src: 'bidvertiser.png',
    }
  },
  'MGID':{
    img:{
      src: 'mgid.svg',
    }
  },
  'Outbrain':{
    img:{
      src: 'outbrain.svg',
    }
  },
  'PlugRush':{
    img:{
      src: 'plugrush.png',
    }
  },
  'PopAds':{
    img:{
      src: 'popads.jpg',
    }
  },
  'PopCash':{
    img:{
      src: 'popcash.svg',
    },
    style:{
      'max-height':'30px'
    }
  },
  'PropellerAds':{
    img:{
      src: 'propeller.png',
    }
  },
  'Pushground':{
    img:{
      src: 'pushground.svg',
    }
  },
  'ReachEffect':{
    img:{
      src: 'reacheffect.png',
    },
    style:{
      'max-height':'30px'
    }
  },
  'Revcontent':{
    img:{
      src: 'revc-ontent.svg',
    }
  },
  'RichAds':{
    img:{
      src: 'richads.svg',
    }
  },
  'RUNative':{
    img:{
      src: 'runative.svg',
    },
    style:{
      'max-height':'25px'
    }
  },
  'SelfAdvertiser':{
    img:{
      src: 'selfadvertiser.png',
    }
  },
  'Taboola':{
    img:{
      src: 'taboola.svg',
    },
    style:{
      'max-height':'20px'
    }
  },
  'Tonic':{
    img:{
      src: 'tonic.svg',
    }
  },
  'TrafficJunky':{
    img:{
      src: 'trafficjunky.svg',
    }
  },
  'UngAds':{
    img:{
      src: 'ungads.png',
    },
    style:{
      'max-height':'30px'
    }
  },
  'Zeropark':{
    img:{
      src: 'zeropark.svg',
    }
  },
  'Mondiad':{
    img:{
      src: 'mondiad.png',
    }
  },
  'TrafficStars':{
    img:{
      src: 'trafficstars.png',
    }
  },
  'MyBid':{
    img:{
      src: 'mybid.png',
    }
  },
  'TrafficShop':{
    img:{
      src: 'trafficshop.svg',
    }
  },
  'Microsoft Advertising':{
    img:{
      src: 'microsoft-advertising.png',
    }
  },
} as {[type: string]: {
    img:{
      src: string
    }
  }}
